<div class="clearfix">
    <ul class="p-account-nav">
        {{if (!accountTab || accountTab == 0)}}
        <li class="active">账户明细</li>
        {{else}}
        <li>账户明细</li>
        {{/if}}
        <li>特惠时长</li>
        <li>优惠券</li>
        {{if (userinfo.RoleID == 1 || userinfo.RoleID == 3)&& userinfo.LiveType == 0 }}

        {{else}}
            {{if (accountTab && accountTab == 4)}}
            <li class="active">银行卡</li>
            {{else}}
            <li>银行卡</li>
            {{/if}}
            {{if (accountTab && accountTab == 3)}}
            <li class="active">提现</li>
            {{else}}
            <li>提现</li> 
            {{/if}}
        {{/if}}
    </ul>
    <div class="p-account-content">
        <div class="p-account-content-item active">
            <div class="p-yue-con">
                <div class="yue-info">
                    <h1>余额 : {{TotalCanUseCash}}声币</h1>
                    <h3>
                        <span>基本账户：{{SetCanUseCash}}声币</span>
                        <span>收入账户：{{GetCanUseCash}}声币</span>
                    </h3>
                </div>
                <a class="recharge-btn" href="./recharge.html">去充值</a>
            </div>
            <div class="detail-con">
                <h3 class="detail-title">账户明细</h3>
                <div id="consumption-con">
                </div>
            </div>
        </div>
        <div class="p-account-content-item" id="freeCallTime">
            
        </div>
        <div class="p-account-content-item" id="couponCon">
            
        </div>
        {{if (userinfo.RoleID == 1 || userinfo.RoleID == 3)&& userinfo.LiveType == 0 }}

        {{ else }}
            <div class="p-account-content-item" id="bankcardCon">
            </div>
            <div class="p-account-content-item" id="tixianCon">
            </div>
        {{/if}}
        
    </div>

</div>